// japanLanguage.ts
// ─── Astria Japan — EN/JA language ─────────────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): Japanese when
// that is the preference, English otherwise. Shared by every Japan screen so
// a form and its result page can never disagree.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../utils/appLanguage";

export type JapanLang = "en" | "ja";

const SUPPORTED: readonly JapanLang[] = ["en", "ja"];

const resolve = (appLanguage: string): JapanLang =>
  pickLanguage(appLanguage, SUPPORTED);

export const getJapanLang = (): JapanLang => resolve(getAppLanguage());

export function useJapanLanguage(): JapanLang {
  return resolve(useAppLanguage());
}
